export enum ProposalStyleClassNames {
  ProposalTableFieldName = 'proposal-table-field-name',
  ProposalTableTotal = 'proposal-table-total',
  ProposalTableGrandTotal = 'proposal-table-grand-total',
  ProposalTableContent = 'proposal-table-content',
  ProposalTableGroup = 'proposal-table-group',
  ProposalTableIndentField = 'proposal-table-indent-field',
  ProposalTableAllocationAdjustments = 'proposal-table-allocation-adjustments',
  ProposalEven = 'proposal-even',
  ProposalOdd = 'proposal-odd',
  ProposalBold = 'proposal-bold',
  ProposalNAValue = 'proposal-na-value',
}
